const useMusic = () => {
  const play = (url) => {
    const audd = new Audio(url);
    audd.play();
  };
  return play;
};

export default useMusic;
